'use client';

import { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { SearchFilter } from '@/features/pages/home/components/Hero/SearchFilter';
import { useGetHousingList } from '@/queris';
import { COLORS } from '@/constants';
import { OfferType } from '@/types';
import dynamic from 'next/dynamic';

const Carousel = dynamic(() => import('./Carousel').then((m) => ({ default: m.Carousel })), {
  ssr: false,
});

import { HousingNotFoundIcon, Loader } from '@/components';
import {
  NotFoundContainer,
  NotFoundHeader,
  SearchSection,
  RecommendationsSection,
  NotFoundHeaderBox,
} from './styled';
import { Container, LoaderBox, Wrapper } from '../housing-detail/styles';

export const NotFound: FC = () => {
  const t = useTranslations();

  const { data, isPending } = useGetHousingList(
    { offerType: OfferType.SELL },
    { queryKey: ['housing-not-found-list'] },
  );

  if (isPending) {
    return (
      <Wrapper>
        <Container>
          <LoaderBox>
            <Loader />
          </LoaderBox>
        </Container>
      </Wrapper>
    );
  }

  return (
    <NotFoundContainer>
      <NotFoundHeader>
        <HousingNotFoundIcon />
        <NotFoundHeaderBox>
          <Typography component="h1" fontWeight={700} fontSize={32} lineHeight={'40px'}>
            {t('housingNotFound.title')}
          </Typography>
          <Typography variant="body1" fontSize={16} lineHeight={'24px'} fontWeight={500}>
            {t('housingNotFound.description')}{' '}
            <Link href="/" style={{ color: COLORS['blue-light-2'], textDecoration: 'underline' }}>
              {t('housingNotFound.startLink')}
            </Link>{' '}
            {t('housingNotFound.descriptionEnd')}
          </Typography>
        </NotFoundHeaderBox>
      </NotFoundHeader>

      <SearchSection>
        <SearchFilter />
      </SearchSection>

      {data && data.objects && data.objects.length > 0 && (
        <RecommendationsSection>
          <Carousel data={data.objects} />
        </RecommendationsSection>
      )}
    </NotFoundContainer>
  );
};
